import React, { useContext, useEffect } from "react";
import { NetworkRedirectContainer } from "./NetworkRedirectStyled";
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { UserContext } from "../../context/userContext";
import { getAccessTokenYoutube, getMyFollowersNetworks, validateStateYoutube } from "../../api/networksApi";
import { useState } from "react";
import Spinner from "../../components/Spinner/Spinner";
import Alert from "../../components/Alert/Alert";
import Lottie from 'react-lottie';
import * as animationData from './facebook-logo-effect.json';
import { URLplatform } from "../../utils/constants/constants";

export default function FacebookRedirect() {

    const navigate = useNavigate();

    const { userType, userToken, id, setFacebookFollowers } = useContext(UserContext);

    //const [isLoading, setIsLoading] = useState(true);
    const [isStopped, setIsStopped] = useState(false);
    const [isPaused, setIsPaused] = useState(false);

    const [showAlertError, setShowAlertError] = useState(false);
    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);

    //Accedemos a los valores
    let code = urlParams.get('code');

    useEffect(() => {

        if (userType !== '' && id !== null) {
            setTimeout(() => {
                getMyFollowersNetworks({ userId: id, typeUser: userType }).then((response) => {
                    setFacebookFollowers(response[0].followers.facebook)
                    setIsStopped(true);
                    //navigate('/myprofile');
                    window.location.replace(`${URLplatform}/myprofile`);
                })
            }, 5000)

        }

    }, [userType, id])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <NetworkRedirectContainer>

            <Lottie options={defaultOptions}
                height={200}
                width={200}
                isStopped={isStopped}
                isPaused={isPaused} />

        </NetworkRedirectContainer>

    )
}